export default "__VITE_ASSET__DRxdkgYa__"